import { hidePostModal } from "../actions";
import mixpanel from "../services/mixpanel";
export const routerLocationChanged = store => next => action => {
  // NOTE: use window.history.state
  if (
    action.type === "ROUTER_LOCATION_CHANGED" &&
    action.payload.route !== "/posts/:id" &&
    store.getState().posts.isPostModalOpen
  ) {
    store.dispatch(hidePostModal());
  }
  if (action.type === "ROUTER_LOCATION_CHANGED") {
    const { payload: { params = {}, result: { title = "untitled" } = {} } } = action;
    mixpanel.track(`page.view.${title}`, params);
  }
  next(action);
};

export default {
  routerLocationChanged,
};



// WEBPACK FOOTER //
// ./src/middleware/locationChange.js